(() => {
  'use strict';
  const source=document.querySelector('[data-uspe-photo-map]');
  if(!source)return;
  const entries=Object.entries(JSON.parse(source.textContent));
  const resolve=value=>entries.find(([filename])=>value?.includes(filename))?.[1];
  function update(img){
    if(!img.matches?.('img'))return;
    const replacement=resolve(img.getAttribute('src'))||resolve(img.getAttribute('data-src'))||resolve(img.getAttribute('srcset'));
    if(!replacement)return;
    img.src=replacement;
    img.removeAttribute('srcset');
    if(img.hasAttribute('data-src'))img.setAttribute('data-src',replacement);
    img.parentElement?.querySelectorAll('source').forEach(node=>{if(resolve(node.srcset))node.srcset=replacement;});
    const link=img.closest('a[href]');
    if(link&&resolve(link.getAttribute('href')))link.href=replacement;
  }
  function scan(root){if(root.matches?.('img'))update(root);root.querySelectorAll?.('img').forEach(update);}
  scan(document);
  new MutationObserver(records=>{
    records.forEach(record=>{
      if(record.type==='attributes')update(record.target);
      else record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);});
    });
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','data-src']});
})();
